import { AxiosResponse } from "axios";
import { isFunction } from "lodash";
import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { useChatApi } from "./useChatApi";

export function useChatRenameConversation(
  options?: UseMutationOptions<
    AxiosResponse<number>,
    unknown,
    [number, string, string]
  >
) {
  const api = useChatApi();
  const queryClient = useQueryClient();
  const { onSuccess, ...rest } = options || {};
  return useMutation((vars) => api.renameConversation(...vars), {
    onSuccess: async (data, vars, ctx) => {
      isFunction(onSuccess) && onSuccess(data, vars, ctx);
      await queryClient.invalidateQueries(["chat-conversations"]);
    },
    ...rest,
  });
}
